import { assign } from '@atds-legacy/lang';
import { Record } from '@redge-media/fo-js-sdk';
import bookmark, { defaultBookmark } from '@/shared/libs/helpers/bookmark';
import favourite from '@/shared/libs/helpers/favourite';
import cover from '@/shared/libs/helpers/cover';

const Episode = Record.mixin(cover).extend({
  constructor: function Episode(attrs = {}, opts = {}) {
    Record.call(this, assign(attrs, {
      favourite: false,
      bookmark: attrs.bookmark || assign({}, defaultBookmark),
    }), opts);

    assign(this, favourite(this), bookmark(this));
  },
});

export default Episode;
